import image from 'shared/assets/images/integrationsSliders/close/close.png'
import { LINK_CLOSE_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const close: IntegrationDetailsData = {
  subheadline: 'Power your inside sales CRM with direct messaging capabilities.',
  overview:
    'Connect Salesmsg with Close to streamline your workflow and keep your CRM data up to date. When you engage with contacts through Salesmsg, relevant information flows to Close, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and CRM workflows',
  ],
  images: [image],
  docs: LINK_CLOSE_INTEGRATION_GUIDE,
}
